import apiClient from './apiClient';

export interface InvoiceItem {
  description?: string;
  name?: string;
  quantity: number;
  unit_price_cents?: number;
  unitPriceCents?: number;
  total_cents?: number;
  totalCents?: number;
}

export interface Invoice {
  id: string;
  number: string;
  clientId: string;
  patientId?: string;
  appointmentId?: string;
  amountCents: number;
  paidAmountCents: number;
  status: string;
  issueDate: string;
  dueDate: string;
  currency: string;
  items: InvoiceItem[];
  notes?: string;
  client?: { id: string; firstName: string; lastName: string; email?: string; phone?: string };
}

class InvoicesService {
  async list(params: { status?: string; dateFrom?: string; dateTo?: string; search?: string; page?: number; pageSize?: number }) {
    const res = await apiClient.get('/invoices', { params });
    return res.data.data;
  }

  async get(id: string) {
    const res = await apiClient.get(`/invoices/${id}`);
    return res.data.data;
  }

  async create(payload: { client_id: string; patient_id?: string; appointment_id?: string; items: InvoiceItem[]; notes?: string }) {
    const res = await apiClient.post('/invoices', payload);
    return res.data.data;
  }

  async update(id: string, payload: { items?: InvoiceItem[]; notes?: string }) {
    const res = await apiClient.patch(`/invoices/${id}`, payload);
    return res.data.data;
  }

  async issue(id: string) {
    const res = await apiClient.post(`/invoices/${id}/issue`);
    return res.data.data;
  }

  async storno(id: string, reason?: string) {
    const res = await apiClient.post(`/invoices/${id}/storno`, { reason });
    return res.data.data;
  }

  async addPayment(id: string, amountCents: number, method: string) {
    const res = await apiClient.post(`/invoices/${id}/payments`, { amount_cents: amountCents, method });
    return res.data.data;
  }

  async getPdfBlob(id: string): Promise<Blob> {
    const res = await apiClient.get(`/invoices/${id}/pdf`, { responseType: 'blob' });
    return res.data;
  }
}

export const invoicesService = new InvoicesService();
